// GENERATED by scripts/clusters-gen.ts — do not edit by hand.
// Flat hub -> supporting-guide link index. Keeping it generated means hub
// pages ship a few KB of slugs instead of importing every guide body.

export const CLUSTER_INDEX: Record<string, { slug: string; title: string }[]> = {
  "/breeding": [
    {
      "slug": "palworld-breeding-calculator-all-combos",
      "title": "Palworld Breeding Calculator: All Combos"
    },
    {
      "slug": "palworld-breeding-passive-skill-odds",
      "title": "Palworld Breeding Passive Skill Odds"
    },
    {
      "slug": "palworld-breeding-cake-farm-setup",
      "title": "Palworld Cake Farm Setup for Breeding"
    },
    {
      "slug": "palworld-legendary-breeding-combos",
      "title": "Palworld Legendary Breeding Combos"
    },
    {
      "slug": "palworld-egg-hatch-times-incubator",
      "title": "Palworld Egg Hatch Times & Incubators"
    },
    {
      "slug": "palworld-anubis-breeding",
      "title": "How to Breed Anubis in Palworld — Full Combo Path"
    },
    {
      "slug": "palworld-best-breeding-combos",
      "title": "Best Breeding Combos in Palworld — Ranked List"
    },
    {
      "slug": "palworld-cake-recipe-guide",
      "title": "Palworld Cake Recipe — Ingredients & Fast Farm"
    },
    {
      "slug": "palworld-egg-hatching-guide",
      "title": "Palworld Egg Hatching Guide — Times & Temperature"
    },
    {
      "slug": "palworld-breeding-stats-ivs",
      "title": "Palworld Breeding Stats & IVs — What Carries Over"
    },
    {
      "slug": "palworld-breeding-combos-list",
      "title": "Palworld Breeding Combos List — Full Parent Chart"
    }
  ],
  "/map": [
    {
      "slug": "palworld-map-dungeon-locations",
      "title": "Palworld Map Dungeon Locations"
    },
    {
      "slug": "palworld-map-fast-travel-statues",
      "title": "Palworld Map Fast Travel Statues"
    },
    {
      "slug": "palworld-map-alpha-boss-locations",
      "title": "Palworld Map Alpha Boss Locations"
    },
    {
      "slug": "palworld-map-ore-farming-locations",
      "title": "Palworld Map Ore Farming Locations"
    },
    {
      "slug": "palworld-map-region-level-order",
      "title": "Palworld Map Region Level Order"
    },
    {
      "slug": "palworld-bounty-tokens",
      "title": "Palworld Bounty Tokens"
    },
    {
      "slug": "palworld-skill-fruit-trees",
      "title": "Palworld Skill Fruit Trees"
    },
    {
      "slug": "palworld-pure-quartz",
      "title": "Palworld pure quartz locations"
    },
    {
      "slug": "palworld-sulfur-farming",
      "title": "Palworld sulfur farming routes"
    },
    {
      "slug": "palworld-lifmunk-effigies",
      "title": "Palworld Lifmunk effigy locations"
    }
  ],
  "/deck-builder": [
    {
      "slug": "palworld-tcg-starter-deck-list",
      "title": "Palworld TCG Starter Deck List"
    },
    {
      "slug": "palworld-tcg-energy-cost-curve",
      "title": "Palworld TCG Energy and Cost Curve"
    },
    {
      "slug": "palworld-tcg-playgroup",
      "title": "Palworld TCG Playgroup Setup"
    },
    {
      "slug": "palworld-tcg-accessories-sleeves-playmats-boxes",
      "title": "Palworld TCG Sleeves & Playmats"
    }
  ],
  "/tcg-tools": [
    {
      "slug": "palworld-card-game-how-to-play",
      "title": "Palworld Card Game How to Play"
    },
    {
      "slug": "palworld-tcg-soul-card-rules",
      "title": "Palworld TCG Soul Card Rules"
    },
    {
      "slug": "palworld-tcg-event-organizing",
      "title": "Palworld TCG Event Organizing"
    },
    {
      "slug": "palworld-tcg-sleeve-and-card-set-vol-1",
      "title": "Palworld TCG Sleeve & Card Set Vol. 1"
    },
    {
      "slug": "palworld-card-game-beginners",
      "title": "Palworld card game for beginners"
    },
    {
      "slug": "palworld-tcg-release-dates",
      "title": "Palworld TCG release dates"
    },
    {
      "slug": "palworld-soul-card-upgrades",
      "title": "Palworld Soul card upgrades"
    }
  ],
  "/prices": [
    {
      "slug": "palworld-tcg-card-values-price-guide",
      "title": "Palworld TCG Card Values Price Guide"
    },
    {
      "slug": "palworld-tcg-graded-card-values",
      "title": "Palworld TCG Graded Card Values"
    },
    {
      "slug": "palworld-tcg-sealed-investment",
      "title": "Palworld TCG Sealed Product Guide"
    },
    {
      "slug": "palworld-card-auction-prices",
      "title": "Palworld Card Auction Prices"
    },
    {
      "slug": "palworld-graded-card-comps",
      "title": "Palworld Graded Card Comps"
    },
    {
      "slug": "palworld-tcgplayer-prices",
      "title": "Palworld TCGplayer Prices"
    },
    {
      "slug": "palworld-official-merchandise",
      "title": "Palworld Official Merchandise"
    },
    {
      "slug": "palworld-plush-and-figures",
      "title": "Palworld Plush and Figures"
    },
    {
      "slug": "palworld-tcg-investing-guide",
      "title": "Palworld TCG Investing Guide"
    },
    {
      "slug": "palworld-tcg-singles",
      "title": "Palworld TCG singles buying guide"
    },
    {
      "slug": "palworld-tcg-error-cards",
      "title": "Palworld TCG error & misprint values"
    },
    {
      "slug": "palworld-tcg-first-edition",
      "title": "Palworld first edition & sealed"
    }
  ],
  "/cards": [
    {
      "slug": "palworld-tcg-best-cards-ranked",
      "title": "Palworld TCG Best Cards Ranked"
    },
    {
      "slug": "palworld-tcg-set-list-checklist",
      "title": "Palworld TCG Set List Checklist"
    },
    {
      "slug": "palworld-tcg-legends-awaken-bp02",
      "title": "Palworld TCG Legends Awaken (BP02)"
    },
    {
      "slug": "palworld-gift-guide",
      "title": "Palworld Gift Guide"
    },
    {
      "slug": "palworld-collecting-guide",
      "title": "Palworld Collecting Guide"
    },
    {
      "slug": "palworld-card-list-guide",
      "title": "Palworld card list and card codes"
    },
    {
      "slug": "palworld-ocg-vs-tcg-print",
      "title": "Palworld OCG vs TCG print differences"
    },
    {
      "slug": "palworld-tcg-promo-card-values",
      "title": "Palworld promo card values"
    }
  ],
  "/booster-pack": [
    {
      "slug": "palworld-tcg-pull-rates-explained",
      "title": "Palworld TCG Pull Rates Explained"
    },
    {
      "slug": "palworld-mystery-boxes-and-blind-boxes",
      "title": "Palworld Mystery Boxes and Blind Boxes"
    }
  ],
  "/trades": [
    {
      "slug": "palworld-tcg-card-trading",
      "title": "Palworld TCG Card Trading"
    },
    {
      "slug": "palworld-tcg-community-finder",
      "title": "Palworld TCG Community Finder"
    }
  ],
  "/want-list": [
    {
      "slug": "palworld-tcg-want-list",
      "title": "Palworld TCG Want List"
    },
    {
      "slug": "palworld-tcg-safe-trading",
      "title": "Palworld TCG Safe Trading"
    }
  ],
  "/tcg-price-index": [
    {
      "slug": "palworld-card-liquidity-score",
      "title": "Palworld Card Liquidity Scores"
    },
    {
      "slug": "palworld-tcg-community-prices",
      "title": "Palworld TCG Community Price Talk"
    },
    {
      "slug": "palworld-trading-card-game",
      "title": "Palworld trading card game guide"
    },
    {
      "slug": "palworld-card-price-tracking",
      "title": "Palworld card price tracking"
    }
  ],
  "/items": [
    {
      "slug": "palworld-starfruit",
      "title": "Palworld Starfruit"
    },
    {
      "slug": "palworld-stat-fruits",
      "title": "Palworld Stat Fruits"
    }
  ],
  "/pals": [
    {
      "slug": "palworld-condensation-star-ranks",
      "title": "Palworld Condensation & Star Ranks"
    },
    {
      "slug": "palworld-plushies-buying-guide",
      "title": "Palworld Plushies Buying Guide"
    },
    {
      "slug": "palworld-collectible-figures-and-limited-editions",
      "title": "Palworld Collectible Figures"
    }
  ],
  "/guides": [
    {
      "slug": "palworld-apparel-shirts-and-hoodies",
      "title": "Palworld Apparel: Shirts and Hoodies"
    },
    {
      "slug": "palworld-accessories-keychains-stickers-posters",
      "title": "Palworld Keychains, Stickers & Posters"
    }
  ],
  "/technology-tree": [
    {
      "slug": "palworld-ancient-technology-points",
      "title": "Palworld ancient technology points"
    },
    {
      "slug": "palworld-schematics",
      "title": "Palworld schematics farming guide"
    },
    {
      "slug": "palworld-crossplay",
      "title": "Is Palworld crossplay?"
    },
    {
      "slug": "palworld-platforms",
      "title": "Palworld platforms: PS5, Xbox, Switch, PC"
    },
    {
      "slug": "palworld-mobile-release-date",
      "title": "Palworld mobile release date"
    },
    {
      "slug": "palworld-dedicated-server",
      "title": "Palworld dedicated server setup"
    },
    {
      "slug": "palworld-console-commands",
      "title": "Palworld console commands list"
    }
  ]
};
